import { ia } from 'lib/helpers/utility';

export const extractDateValue = (value, isDateRange) => {
  if (!value) return null;

  // For date ranges, return the array as-is
  if (isDateRange && ia(value)) {
    return value;
  }

  // For time range with single date (value is array but isDateRange is false)
  // Return the first element as the single date
  if (!isDateRange && ia(value)) {
    return value[0] || null;
  }

  return value;
};

export const extractTimeValue = (value, isTimeRange) => {
  if (!value) return null;

  // For ranges, return the array as-is (dates will be used for their time portion)
  if (isTimeRange && ia(value)) {
    return value;
  }

  // For single values, return as-is
  return value;
};
